import {Component, Input, OnInit, output} from '@angular/core';
import {Params, RouterLink} from '@angular/router';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatOption, MatSelect} from '@angular/material/select';

import {AppService} from 'shared/services';
import {ContentState} from 'shared/types';
import {ListState} from 'shared/interfaces';
import {OrganizationModel, TokenUserModel} from 'shared/models';
import {CustomizerSettingsService} from '../../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-organization-ui',
  standalone: true,
  imports: [RouterLink, MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule, ReactiveFormsModule, MatSelect, MatOption],
  templateUrl: './organization-ui.component.html',
  styleUrl: './organization-ui.component.scss'
})
export class OrganizationUiComponent implements OnInit {
  // state = input<ContentState<ListState<OrganizationModel>>>();
  @Input()
  organizationsState!: ContentState<ListState<OrganizationModel>> | null;
  protected submitClick = output<Params>();

  protected form!: FormGroup;

  protected currentUser?: TokenUserModel;

  constructor(
    private fb: FormBuilder,
    protected themeService: CustomizerSettingsService,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.currentUser = this.appService.currentUser;

    this.initForm();
  }

  private initForm() {
    this.form = this.fb.group({
      organizationId: ['', Validators.required],
    });

    if (this.currentUser) {
      this.form.get('organizationId')?.setValue(this.currentUser.organization?.strId);
    }
  }

  submit({value, valid}: {value: Params; valid: boolean}) {
    const formData = {...value};
    this.submitClick.emit(formData);
  }
}
